import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/medical-service-provider/files`;

export const files = {
  get: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
};
